import { Permission, TicketLineDTO, TicketLineStatus, Res } from 'core/api';
import { Command } from 'pos/common';
import * as SalesStore from 'pos/modules/main/SalesStore';
import { Result } from 'core/infrastructure';
import { Preconditions } from 'core/infrastructure-next';
import { Message } from 'core/ui-next/modal';

declare global {
	interface CommandType {
		requestTicketLine: (line: TicketLineDTO) => Promise<Result>
	}
}

Command.register('requestTicketLine', Preconditions.ensure(Permission.Ticket_RequestOrderedLine), async (line: TicketLineDTO): Promise<Result> => {
	if (line.Status === TicketLineStatus.New) {
		await Message.show(Res.Msg.MSG_LINE_INVALID_STATUS_TO_BE_REQUESTED());
		return Result.error();
	}

	if (line.PreparationOrderId === 0) {
		await Message.show(Res.Msg.MSG_LINE_INVALID_ORDER_TO_BE_REQUESTED());
		return Result.error();
	}

	if (!line.PreparationOrderCanBeRequested) {
		await Message.show(Res.Msg.MSG_LINE_ORDER_CANNOT_BE_REQUESTED(line.PreparationOrderName));

		return Result.error();
	}


	await SalesStore.requestLine(line.Id);
	return Result.ok();

});